module.exports = __webpack_public_path__ + "img/205.128cc0b0.jpg";